import { createNomogramWidget } from './shared/nomogram.js';
import fields from './shared/fields.js';
import colors from './shared/colors.js';

const survivalWidgetApp = createNomogramWidget({
    dataApi: '/umbraco/api/survival/calculate',
    errorMessage: 'Failed to calculate survival',
    chartColors: [
        colors.green,
        colors.black,
        colors.red,
        colors.orange,
        colors.yellow,
    ],
    fields: [
        fields.Age,
        fields.ProstateSize,
        fields.PSA,
        fields.ISUPGradeBx,
        fields.CT,
        fields.CN,
    ],
    payload: vm => ({
        Age: vm.Age,
        ProstateSize: vm.ProstateSize,
        PSA: vm.PSA,
        ISUPGradeBx: vm.ISUPGradeBx,
        CT: vm.CT,
        CN: vm.CN,
    }),
});

export default survivalWidgetApp;
